export type CostDocumentReference = {
  id: string;
  label: string;
  status: "attached" | "needed" | "pending";
  uploadId?: string | null;
};

export type FiledCostDocument = {
  documentId: string;
  uploadId: string;
  name: string;
};

/** Build the ledger reference from the canonical Document and Upload IDs. */
export function toAttachedCostDocumentReference(
  document: FiledCostDocument,
): CostDocumentReference {
  return {
    id: document.documentId,
    label: document.name,
    status: "attached",
    uploadId: document.uploadId,
  };
}

/** Replace an existing link when retrying, rather than appending a duplicate. */
export function mergeCostDocumentReferences(
  existing: CostDocumentReference[],
  next: CostDocumentReference,
): CostDocumentReference[] {
  return [...existing.filter((document) => document.id !== next.id), next];
}

/** Find a record attachment created from the same upload after a retry. */
export function hasCostDocumentUpload(
  documents: readonly { uploadId?: string | null }[],
  uploadId: string,
): boolean {
  return documents.some((document) => document.uploadId === uploadId);
}
